import { PageTypeEnum } from '@/utils/enum';
import { FlexEnum, ModeEnum } from '@hylaa-npm/ipod';
import { IReduxAction, IReduxState } from './redux';
import types from './type';

export const initState = {
	currentPageType: PageTypeEnum.SYSTEM_PAGE,
	loginStatus: false,
	userInfo: {},
	clients: [],
	userInit: false,
	userLang: 0,
	currentTheme: null,
	currentFavor: {
		layoutCode: FlexEnum.TOP,
		patternCode: ModeEnum.SIMPLE,
	},
	allThemes: {
		themes: [],
		backgrounds: {
			left: [],
			right: [],
		},
	},
};

function reducers(state: IReduxState = initState, action: IReduxAction) {
	switch (action.type) {
		case types.CHANGE_LOGIN_STATUS:
			return { ...state, ...{ loginStatus: action.data } };
		case types.CHANGE_CLIENTS:
			return { ...state, ...{ clients: action.data } };
		case types.CHANGE_CURRENT_PAGE_TYPE:
			return { ...state, ...{ currentPageType: action.data } };
		case types.CHANGE_USERINFO:
			return { ...state, ...{ userInfo: action.data } };
		case types.CHANGE_USERINIT:
			return { ...state, ...{ userInit: action.data } };
		case types.CHANGE_CURRENT_FAVOR:
			return { ...state, ...{ currentFavor: action.data } };
		case types.CHANGE_USER_LANG:
			return { ...state, ...{ userLang: action.data } };
		// 全部主题
		case types.CHANGE_ALL_THEMES:
			return { ...state, ...{ allThemes: action.data } };
		// 全部主题
		case types.CHANGE_CURRENT_THEME:
			return { ...state, ...{ currentTheme: action.data } };
		default:
			return state;
	}
}

export default reducers;
